(() => {
  if (!('IntersectionObserver' in window) || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  const observer = new IntersectionObserver(entries => {
    entries.forEach(entry => {
      if (!entry.isIntersecting) return;
      entry.target.classList.add('me-reveal-visible');
      observer.unobserve(entry.target);
    });
  }, { threshold: 0.08, rootMargin: '0px 0px -32px 0px' });

  function init(root = document) {
    root.querySelectorAll('.me-featured .me-shop__grid > li, .me-home-assortment__visual, .me-home-assortment__copy, .me-inspiration > div:first-child, .me-inspiration__image').forEach(element => {
      if (element.classList.contains('me-reveal-pending')) return;
      element.classList.add('me-reveal-pending');
      observer.observe(element);
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init(), { once: true });
  else init();
  document.addEventListener('shopify:section:load', event => init(event.target));
})();
